/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropAchievementConditionProgress
 */
export interface DropAchievementConditionProgress {
    /**
     * 
     * @type {string}
     * @memberof DropAchievementConditionProgress
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof DropAchievementConditionProgress
     */
    threshold: number;
    /**
     * Capped at threshold so a display bar never overflows.
     * @type {number}
     * @memberof DropAchievementConditionProgress
     */
    current: number;
    /**
     * 
     * @type {boolean}
     * @memberof DropAchievementConditionProgress
     */
    met: boolean;
    /**
     * What the numbers COUNT — "Likes", "Finds". Authored per checkpoint, because every checkpoint badge shares one condition type and the surface was printing that type's generic name against all of them.
     * @type {string}
     * @memberof DropAchievementConditionProgress
     */
    unit?: string;
}

/**
 * Check if a given object implements the DropAchievementConditionProgress interface.
 */
export function instanceOfDropAchievementConditionProgress(value: object): value is DropAchievementConditionProgress {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('threshold' in value) || value['threshold'] === undefined) return false;
    if (!('current' in value) || value['current'] === undefined) return false;
    if (!('met' in value) || value['met'] === undefined) return false;
    return true;
}

export function DropAchievementConditionProgressFromJSON(json: any): DropAchievementConditionProgress {
    return DropAchievementConditionProgressFromJSONTyped(json, false);
}

export function DropAchievementConditionProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropAchievementConditionProgress {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'threshold': json['threshold'],
        'current': json['current'],
        'met': json['met'],
        'unit': json['unit'] == null ? undefined : json['unit'],
    };
}

export function DropAchievementConditionProgressToJSON(json: any): DropAchievementConditionProgress {
    return DropAchievementConditionProgressToJSONTyped(json, false);
}

export function DropAchievementConditionProgressToJSONTyped(value?: DropAchievementConditionProgress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'threshold': value['threshold'],
        'current': value['current'],
        'met': value['met'],
        'unit': value['unit'],
    };
}

